import React from "react";
import styles from "./Navbar.module.scss";
import Button from "components/UI/Button/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Menu from "./Menu";
import CreativesLogoSVG from "components/SVGComponents/CreativesLogoSVG";
import { getAccessToken } from "utils/utils";

const navLinks = [
  {
    name: "Home",
    href: "/",
  },
  {
    name: "About",
    href: "/about-us",
  },
  {
    name: "Contact",
    href: "/contact-us",
  },
];

const Navbar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return (
    <nav className={styles.navbar}>
      {/* <QreativesLogo height="50" width="150" href={"/"} /> */}
      <Link to={"/feed"}>
        <CreativesLogoSVG />
      </Link>

      <ul>
        {navLinks.map((nav) => (
          <li key={nav.name}>
            <Link
              className={pathname === nav.href && styles.active}
              to={nav.href}
            >
              {nav.name}
            </Link>
          </li>
        ))}
      </ul>
      {!getAccessToken() && (
        <div className={styles.btns}>
          <Button
            onClick={() => navigate("/signin")}
            className={styles.btn}
            variant="outlined"
          >
            Log In
          </Button>
          <Button
            onClick={() => navigate("/signup")}
            className={styles.btn}
            variant="filled"
          >
            Sign Up
          </Button>
        </div>
      )}
      <Menu tabs={navLinks} />
    </nav>
  );
};

export default Navbar;
